import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import CheckboxImage from '@images/svg-icons/checkbox.svg';

type CheckboxProps = {
    id: string;
    label: string;
    checked: boolean;
    onChange: () => void;
}

const Checkbox = (props: CheckboxProps) : ReactElement => {
    const { register } = useFormContext();
    const {
        id,
        label,
        checked,
        onChange
    } = props;

    return(
        <label className="checkbox">
            <input {...register(id)} id={id} type="checkbox" checked={checked} onChange={onChange} />
            <span className="checkbox-checkmark">{checked ? <CheckboxImage /> : <></>}</span>
            <span>{label}</span>
        </label>
    )
}

export default Checkbox;